import type { FunctionComponent } from "react";
import { DashboardLayout } from "../../components/dashboard-layout.components";

export const AdminLayoutAdminScreen: FunctionComponent = () => {
	return (
		<div className="">
			<DashboardLayout />
		</div>
	);
};
